import styled, { css } from 'styled-components'
import { Devices, Spacings } from '@styles'
import { BaseWrapper, UploadButton } from '@base'

export const AdminWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`
export const InitialAdminHeaderWrapper = styled(BaseWrapper)`
	margin-bottom: ${Spacings.SPACING_4B};
`

const FormSection = styled.div`
	padding: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_4B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
	display: block;
	@media ${Devices.mobile} {
		display: flex;
	}
`
export const InitialAdminFormWrapper = styled(FormSection)`
	padding: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B};
	&:last-of-type {
		margin-bottom: 0;
	}
`

export const UploadButtonFiled = styled(UploadButton)`
	height: ${Spacings.SPACING_3B};
	width: 100%;
	margin: 0;
	@media ${Devices.mobile} {
		width: 12rem;
		margin: ${Spacings.SPACING_5B} ${Spacings.SPACING_4B} ${Spacings.SPACING_5B} ${Spacings.SPACING_2B};
	}
`
export const StepWrapper = styled(BaseWrapper)`
	flex-grow: 1;
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	${({ isFlex }) => {
		if (isFlex) {
			return css`
				display: flex;
				flex-direction: column;
			`
		}
	}}
`
export const StepTopWrapper = styled(StepWrapper)`
	padding: 0;
	flex-grow: 0;
	margin-bottom: ${Spacings.SPACING_4B};
	display: flex;

	button {
		min-width: fit-content;
	}
`

export const BannerText = styled.div`
	display: flex;
	align-items: center;
	flex-grow: 1;
`